import { COMPANY_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
const TIME_TO_WAIT_BEFORE_CLOSING = 2000;
export const convertToUnixEpoch = dateArray => {
  const [year, month, day] = dateArray;
  const date = new Date(Date.UTC(year, month - 1, day));
  const unixEpoch = Math.floor(date.getTime());
  return unixEpoch;
};
export const getNonEmptyProperties = propertyUpdates => {
  return Object.keys(propertyUpdates).filter(key => propertyUpdates[key].value !== '');
};

/**
 * Returns the object type based on the given objectTypeId.
 *
 * @param {string | null} objectTypeId - The ID of the object type.
 * @returns {string} - The object type ('company' or 'contact').
 */
export const getObjectType = objectTypeId => objectTypeId === COMPANY_TYPE_ID ? 'company' : 'contact';

/**
 * Returns the associated object type based on the given objectTypeId.
 *
 * For example, if we receive CONTACT_TYPE_ID, we return 'company'.
 * If we receive COMPANY_TYPE_ID, we return 'contact'.
 *
 * @param {string | null} objectTypeId - The ID of the object type.
 * @returns {string} - The associated object type ('company' or 'contact').
 */
export const getAssociatedObjectType = objectTypeId => objectTypeId === CONTACT_TYPE_ID ? 'companies' : 'contacts';
export const wait = async (timeout = TIME_TO_WAIT_BEFORE_CLOSING) => {
  await new Promise(resolve => setTimeout(resolve, timeout));
};
export const isContact = objectType => objectType === 'contact';
export const isContactObjectType = objectTypeId => objectTypeId === CONTACT_TYPE_ID;
export function transformEnrichPayload(ids) {
  return ids.map(id => Number(id));
}
/**
 * Gets the appropriate object type label based on type ID and count
 * @param objectTypeId - The ID of the object type
 * @param count - The number of records
 * @param labels - Object containing label variations (e.g., companyLabelLowercase, companyLabelPluralLowercase)
 * @returns The appropriate label string based on type and plurality
 */
export function getObjectTypeLabel(objectTypeId, count, labels) {
  const isPlural = count !== 1;
  let objectTypeLabel;
  if (isContactObjectType(objectTypeId)) {
    if (isPlural) {
      objectTypeLabel = labels.contactLabelPluralLowercase;
    } else {
      objectTypeLabel = labels.contactLabelLowercase;
    }
  } else {
    if (isPlural) {
      objectTypeLabel = labels.companyLabelPluralLowercase;
    } else {
      objectTypeLabel = labels.companyLabelLowercase;
    }
  }
  return objectTypeLabel;
}